<template>
  <div class="d-cal__subjects__subject__dragged"
       ref="d_cal_dragged" :style="styleObj">
    {{ subjectTitle }}
  </div>
</template>

<script>
export default {
  props: {
    deleteSubject: {
      type: Object,
      default: null
    },
    activeSubject: {
      type: Object,
      default: null
    },
    activeSubjectBCR: {
      default: null
    },
    movedX: {
      type: Number,
      default: 0
    },
    movedY: {
      type: Number,
      default: 0
    }
  },
  computed: {
    subjectTitle () {
      return this.activeSubject ? this.activeSubject.title : this.deleteSubject ? this.deleteSubject.title : ''
    },
    styleObj () {
      return {
        'top': this.movedY + 'px',
        'left': this.movedX + 'px',
        'background': this.activeSubject ? this.activeSubject.color : this.deleteSubject ? this.deleteSubject.color : 'transparent',
        'width': this.activeSubjectBCR ? this.activeSubjectBCR.width + 'px' : '165px',
        'height': this.activeSubjectBCR ? this.activeSubjectBCR.height + 'px' : '40px',
        'borderColor': this.activeSubject ? this.activeSubject.color : this.deleteSubject ? this.deleteSubject.color : 'transparent'
      }
    }
  },
  mounted () {
    const el = this.$refs.d_cal_dragged
    // find out where the Subject is clicked
    document.getElementById('djs-content-container').appendChild(el)
  }
}
</script>

<style scoped>
.d-cal__subjects__subject__dragged {
  position: absolute;
  z-index: 32323232;
  top:0;
  left: 0;
  padding: 0 0.5rem;
  font-weight: bold;
  color: #ffffff !important;
  border-radius: 2px;
  word-break: break-all;
  overflow: hidden;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, .3);
  text-align: left;
  padding-left: calc(0.5rem + 3px);
  cursor: pointer;
  pointer-events: none;
  line-height: 40px;
  text-overflow: ellipsis;
}

.d-cal__subjects__subject__dragged:before {
  content: '';
  position: absolute;
  z-index: 32323233;
  top: 0;
  left: 4px;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.2);
}

</style>



// WEBPACK FOOTER //
// DCalendarDraggedSubject.vue?2ee8477b